import { render, staticRenderFns } from "./ResponseTimeCard.vue?vue&type=template&id=2a47d91e&scoped=true&"
import script from "./ResponseTimeCard.vue?vue&type=script&lang=ts&"
export * from "./ResponseTimeCard.vue?vue&type=script&lang=ts&"
import style0 from "./ResponseTimeCard.vue?vue&type=style&index=0&id=2a47d91e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47d91e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
